import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { testAdminToken } from '../../../AdminPages/API/AdminInfo/AdminInfo';
import { AdminUser, TestAdminTokenResponse } from '../../../AdminPages/API/AdminInfo/models';
import Cookies from 'js-cookie';
export const useTestAdminToken = () => {
    const [adminInfo, setAdminInfo] = useState<AdminUser | null>(null)
    const [loadingConnection, setLoadingConnection] = useState(false)
    const [connected, setConnected] = useState(false)
    const navigate = useNavigate();


    const testToken = async () => {
        setLoadingConnection(true)
        const result: TestAdminTokenResponse = await testAdminToken();

        if (result?.user?.id) {
            setConnected(true)
            setAdminInfo(result.user)
        } else {
            Cookies.remove('Token')
            navigate('/admin')
        }

        setLoadingConnection(false)
    }


    useEffect(() => {
        testToken()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {
        adminInfo,
        connected,
        testToken,
        loadingConnection
    }

}
